export const ArchiveWallContainerClass = "article-view__piano-metering";
// This is for providing position from template builder to inject the meter paywall
export const PianoMeteringContainerClass = "piano-metering__paywall-container";
// Paywalled-content boundary for live articles: applied to the SSR live
// contents preview block and referenced by article-schema's hasPart.cssSelector,
// so search engines can tell where the gated live updates live in the DOM.
export const LiveBlogPaywalledContentClass = "live-blog-paywalled-content";
